/*
 * Navigatie van Sentir (sections/header.liquid, opmaak in assets/sentir-nav.css).
 *
 * Desktop (vanaf 1100px): Parfums en Sets & cadeaus zijn megamenu's, Geuradvies en Service kleine uitklapmenu's.
 * - Openen: de muis even op de knop laten rusten (OPEN_MS), of klikken, Enter of Spatie. Pijl omlaag opent het menu
 *   en zet de focus op de eerste link. Nooit alleen hover: op een tablet werkt een tik, met het toetsenbord Enter.
 * - Sluiten: Esc (de focus gaat terug naar de knop), klikken naast het menu, met Tab het menu uit, of de muis eraf
 *   bij een menu dat met de muis openging (met wat speling, DICHT_MS, voor wie schuin naar het paneel beweegt).
 * - Klikt iemand op de knop van een menu dat net met de muis openging, dan blijft het open: anders klapte het onder
 *   de muis meteen weer dicht.
 * - Staat er al een menu open, dan wisselt de muis pas naar een ander menu als hij even stilstaat op die knop
 *   (WISSEL_MS zonder beweging), zonder animatie. Wie schuin van Parfums naar de rechterkant van het paneel beweegt,
 *   schiet over Sets & cadeaus heen en houdt Parfums. Gaat de muis over de balk verder naar de iconen, dan gaat het
 *   menu gewoon dicht.
 * - De foto's in een paneel laden pas als het opengaat (lazy). Komt de muis voor het eerst op een knop, dan laden ze
 *   alvast, tijdens de wachttijd voor het openen.
 * - Schuift de balk weg bij het scrollen (sticky-header in de sectie), dan gaat het menu dicht (sluitPanelen).
 *
 * Telefoon en tablet (onder 1100px): de lade, een <dialog>.
 * - showModal() legt de lade in de top layer, boven alles; de pagina eronder is zolang onbereikbaar. Tab blijft binnen
 *   de lade (ook van de laatste naar de eerste link), Esc en een tik op de waas sluiten hem, de pagina scrolt niet
 *   mee (html.sn-vast). Na het sluiten gaat de focus terug naar de menuknop en staat de pagina weer waar hij stond.
 * - De lade schuift binnen over de plek van de menuknop: een tik in het paneel telt pas als hij er (bijna) helemaal is.
 *   Anders bracht een dubbeltik op de menuknop je via het logo naar de homepage, of via het zoekveld naar de popup.
 * - Het zoekveld in de lade sluit eerst de lade en opent dan de zoekpopup (search-sentir.js), met het zoekicoon in de
 *   balk als opener: daar komt de focus terug als de popup sluit. De volgorde telt: een <dialog> die sluit zet de
 *   focus terug waar hij vandaan kwam, en dat mag niet ná het openen van de popup gebeuren (dan verliest het
 *   zoekveld zijn focus en blijft het toetsenbord op de iPhone dicht).
 * - Links met data-sentir-chat-open openen de eigen chat; dat doet sentir-chat.js zelf. Hier gaat alleen de lade of
 *   het menu dicht.
 *
 * Een tik die binnenkwam voordat dit script er was (sections/header.liquid, "Vroege tik"), voeren we alsnog uit.
 * In de theme editor bouwt Shopify de sectie opnieuw op; dan koppelen we alles opnieuw (shopify:section:load).
 *
 * window.SentirNav = { sluitPanelen, openLade, sluitLade }, voor de sticky-header en andere scripts.
 */
(function () {
  'use strict';

  var OPEN_MS = 140;
  var DICHT_MS = 260;
  var WISSEL_MS = 90; /* stilstand op een andere knop voordat een open menu wisselt */
  var PANEEL_MS = 240; /* gelijk aan de overgang van .sn-paneel in sentir-nav.css */
  var LADE_MS = 340; /* gelijk aan de overgang van .sn-lade__paneel */

  var stil = window.matchMedia('(prefers-reduced-motion: reduce)');
  var breed = window.matchMedia('(min-width: 1100px)'); /* gelijk aan de grens in sentir-nav.css */

  var balk = null;
  var lade = null;
  var open = null;
  var openDoor = null;
  var openTimer = 0;
  var dichtTimer = 0;
  var ladeTimer = 0;
  var ladeScrollY = null;
  var ladeOpenSinds = 0;
  var waasBeeld = 0;

  function knopVan(item) {
    return item.querySelector('[data-sn-knop]');
  }

  function paneelVan(item) {
    return item.querySelector('[data-sn-paneel]');
  }

  function burgerKnop() {
    return balk ? balk.querySelector('[data-sn-burger]') : null;
  }

  /* ------------------------------------------------------------------ panelen -- */

  /* De waas onder een megamenu begint waar de balk ophoudt; ook de hoogte van het paneel rekent daarmee. */
  function zetWaas() {
    if (!balk) return;
    var mega = !!open && open.classList.contains('sn-item--mega');
    if (mega) {
      var onder = Math.max(0, Math.round(balk.getBoundingClientRect().bottom));
      balk.style.setProperty('--sn-waas-top', onder + 'px');
      balk.style.setProperty('--sn-paneel-top', onder + 'px');
    }
    balk.classList.toggle('is-mega-open', mega);
  }

  function toon(item, door) {
    window.clearTimeout(openTimer);
    window.clearTimeout(dichtTimer);
    if (open === item) {
      if (door === 'klik') openDoor = 'klik';
      return;
    }

    var knop = knopVan(item);
    var paneel = paneelVan(item);
    if (!knop || !paneel) return;

    var wissel = !!open;
    if (open) verberg(open, true, true);

    open = item;
    openDoor = door;
    window.clearTimeout(item._snTimer);
    paneel.hidden = false;
    knop.setAttribute('aria-expanded', 'true');

    if (wissel || stil.matches) {
      /* Zonder overgang: meteen in de eindstand. */
      balk.classList.add('is-wissel');
      item.classList.add('is-open');
      void paneel.offsetWidth;
      window.requestAnimationFrame(function () {
        if (balk) balk.classList.remove('is-wissel');
      });
    } else {
      void paneel.offsetWidth; /* beginstand vastleggen, anders is er niets om vanuit te animeren */
      item.classList.add('is-open');
    }
    zetWaas();
  }

  /*
   * direct: zonder uitvegen (wisselen, wegschuivende balk, Esc). stilletjes: de focus niet verplaatsen.
   * Staat de focus nog in het paneel dat dichtgaat (bijvoorbeeld als de balk wegschuift), dan gaat hij naar de knop:
   * anders verdwijnt hij in een verborgen paneel.
   */
  function verberg(item, direct, stilletjes) {
    var knop = knopVan(item);
    var paneel = paneelVan(item);
    item.classList.remove('is-open');
    if (knop) knop.setAttribute('aria-expanded', 'false');
    if (open === item) {
      open = null;
      openDoor = null;
    }
    window.clearTimeout(item._snTimer);
    if (paneel) {
      if (!stilletjes && knop && paneel.contains(document.activeElement)) knop.focus({ preventScroll: true });
      if (direct || stil.matches) {
        paneel.hidden = true;
      } else {
        item._snTimer = window.setTimeout(function () {
          if (!item.classList.contains('is-open')) paneel.hidden = true;
        }, PANEEL_MS);
      }
    }
    zetWaas();
  }

  function sluitPanelen(direct) {
    window.clearTimeout(openTimer);
    window.clearTimeout(dichtTimer);
    if (open) verberg(open, direct);
  }

  /*
   * Er staat al een menu open en de muis komt op een andere knop: pas wisselen als hij daar WISSEL_MS stilstaat. Elke
   * beweging over die knop (pointermove) zet de klok opnieuw, dus wie er schuin overheen schiet, wisselt niet.
   */
  function planWissel(item) {
    window.clearTimeout(openTimer);
    openTimer = window.setTimeout(function () {
      toon(item, 'muis');
    }, WISSEL_MS);
  }

  /*
   * De muis gaat van een knop af: een menu dat met de muis openging, gaat na DICHT_MS dicht, tenzij de muis op tijd
   * terug is in dat menu. Ook als hij over een andere knop wegloopt: die zet bij binnenkomst de klok stil, en bij het
   * weggaan hier weer aan. Zo blijft een menu niet open hangen als de muis over de balk naar de iconen gaat.
   */
  function planDicht() {
    var item = open;
    window.clearTimeout(dichtTimer);
    if (!item || openDoor !== 'muis') return;
    dichtTimer = window.setTimeout(function () {
      if (open === item && openDoor === 'muis') verberg(item);
    }, DICHT_MS);
  }

  /* Eén keer per paneel: de lazy foto's op eager, dan laden ze al tijdens de wachttijd voor het openen (OPEN_MS). */
  function laadBeelden(paneel) {
    if (!paneel || paneel._snGeladen) return;
    paneel._snGeladen = true;
    Array.prototype.forEach.call(paneel.querySelectorAll('img[loading="lazy"]'), function (img) {
      img.loading = 'eager';
    });
  }

  function koppelItem(item) {
    var knop = knopVan(item);
    var paneel = paneelVan(item);
    if (!knop || !paneel) return;

    knop.addEventListener('click', function (e) {
      e.preventDefault();
      if (open === item) {
        if (openDoor === 'muis') {
          openDoor = 'klik';
          return;
        }
        verberg(item);
      } else {
        toon(item, 'klik');
      }
    });

    knop.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'Down') return;
      e.preventDefault();
      toon(item, 'klik');
      var eerste = paneel.querySelector('a[href], button');
      if (eerste) eerste.focus();
    });

    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !breed.matches) return;
      laadBeelden(paneel);
      window.clearTimeout(dichtTimer);
      window.clearTimeout(openTimer);
      if (open === item) return;
      if (open) {
        planWissel(item);
        return;
      }
      openTimer = window.setTimeout(function () {
        toon(item, 'muis');
      }, OPEN_MS);
    });

    item.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !breed.matches || !open || open === item) return;
      planWissel(item);
    });

    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      window.clearTimeout(openTimer);
      if (open && openDoor === 'muis') planDicht();
    });

    /* Met Tab het menu uit. Een klik op een leeg stukje paneel (relatedTarget leeg) laat het open. */
    item.addEventListener('focusout', function (e) {
      var naar = e.relatedTarget;
      if (open === item && naar && !item.contains(naar)) verberg(item);
    });
  }

  /* --------------------------------------------------------------------- lade -- */

  function ladeOpen() {
    return !!lade && lade.hasAttribute('open');
  }

  function focusbaar(el) {
    var dicht = el.closest('details:not([open])');
    if (dicht && !(el.tagName === 'SUMMARY' && el.parentElement === dicht)) return false; /* inhoud van een dicht klapmenu */
    return el.getClientRects().length > 0;
  }

  /*
   * Zolang de lade open is, zet html.sn-vast overflow op hidden (de pagina scrolt niet mee). Daarbij kan de pagina
   * eronder verschuiven: op PageFly-pagina's sprong hij bij het openen naar boven, op collectiepagina's zet Searchanise
   * hem bij Esc bovenaan (zie de focusval hieronder). Dus: positie onthouden bij het openen en na het sluiten
   * terugzetten, zoals het mandje dat ook doet (cart-drawer.js).
   */
  function zetVast() {
    if (!document.documentElement.classList.contains('sn-vast')) {
      ladeScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    }
    document.documentElement.classList.add('sn-vast');
  }

  function zetLos() {
    document.documentElement.classList.remove('sn-vast');
    var y = ladeScrollY;
    ladeScrollY = null;
    if (y !== null && Math.abs((window.pageYOffset || 0) - y) > 1) window.scrollTo(0, y);
  }

  function openLade() {
    if (!lade) return;
    window.clearTimeout(ladeTimer);
    sluitPanelen(true);
    ladeOpenSinds = Date.now();
    zetVast(); /* eerst de scrollpositie onthouden, dan pas openen */
    if (!ladeOpen()) {
      if (typeof lade.showModal === 'function') {
        try {
          lade.showModal();
        } catch (fout) {
          lade.setAttribute('open', '');
        }
      } else {
        lade.setAttribute('open', '');
      }
    }
    var burger = burgerKnop();
    if (burger) burger.setAttribute('aria-expanded', 'true');

    /* De focus op het paneel zelf: een schermlezer meldt "Menu", en de eerste Tab gaat naar het zoekveld. */
    var paneel = lade.querySelector('[data-sn-lade-paneel]');
    if (paneel) paneel.focus({ preventScroll: true });

    void lade.offsetWidth; /* beginstand vastleggen */
    lade.classList.add('is-open');
  }

  /* opties.direct: zonder uitschuiven. opties.focus === false: de focus niet terug naar de menuknop. */
  function sluitLade(opties) {
    opties = opties || {};
    if (!ladeOpen()) return;
    window.clearTimeout(ladeTimer);
    lade.classList.remove('is-open');
    var burger = burgerKnop();
    if (burger) burger.setAttribute('aria-expanded', 'false');

    var klaar = function () {
      if (lade.open && typeof lade.close === 'function') lade.close();
      else lade.removeAttribute('open');
      zetLos();
      if (opties.focus !== false && burger && burger.getClientRects().length) burger.focus({ preventScroll: true });
    };

    if (opties.direct || stil.matches) klaar();
    else ladeTimer = window.setTimeout(klaar, LADE_MS);
  }

  function koppelLade() {
    /* Esc: de browser wil de dialog meteen sluiten; wij willen eerst uitschuiven. */
    lade.addEventListener('cancel', function (e) {
      e.preventDefault();
      sluitLade();
    });

    /* Ging hij toch dicht zonder ons (twee keer snel Esc in Chrome), dan alsnog opruimen. */
    lade.addEventListener('close', function () {
      window.clearTimeout(ladeTimer);
      lade.classList.remove('is-open');
      zetLos();
      var burger = burgerKnop();
      if (burger) burger.setAttribute('aria-expanded', 'false');
    });

    lade.addEventListener('click', function (e) {
      var doel = e.target;
      if (!doel || !doel.closest) return;

      /*
       * Dubbeltik op de menuknop: de tweede tik landt in de lade, die net op die plek binnenschuift. Op het logo stuurde
       * hij je naar de homepage, bovenaan de pagina op het zoekveld opende hij de zoekpopup. Zolang de lade nog
       * binnenschuift telt een tik in het paneel daarom niet, behalve op het kruisje (dat zit rechts, ver van de
       * menuknop). Met het toetsenbord (Enter geeft een klik met detail 0) werkt alles meteen.
       */
      if (
        e.detail > 0 &&
        Date.now() - ladeOpenSinds < LADE_MS + 150 &&
        doel.closest('[data-sn-lade-paneel]') &&
        !doel.closest('[data-sn-lade-dicht]')
      ) {
        e.preventDefault();
        e.stopPropagation(); /* ook de chat (sentir-chat.js luistert op document) doet dan niets */
        return;
      }

      if (doel.closest('[data-sn-lade-dicht]')) {
        e.preventDefault();
        sluitLade();
        return;
      }

      /* Zoeken: lade dicht, dan de zoekpopup. Zonder popup volgt de link gewoon naar de zoekpagina. */
      var zoek = doel.closest('[data-sn-zoek]');
      if (zoek) {
        var popup = document.querySelector('search-sentir');
        var dialoog = popup && popup.querySelector('dialog');
        if (!popup || typeof popup.open !== 'function' || !dialoog || typeof dialoog.showModal !== 'function') return;
        e.preventDefault();
        sluitLade({ direct: true, focus: false });
        var opener = balk && balk.querySelector('.header__search [data-ss-open]');
        popup.open(opener || burgerKnop());
        return;
      }

      /* De eigen chat: sentir-chat.js opent hem; hier alleen de lade dicht, zonder de focus te verplaatsen. */
      if (doel.closest('[data-sentir-chat-open]')) {
        sluitLade({ direct: true, focus: false });
      }
    });

    /*
     * Esc is voor de lade (de browser maakt er een 'cancel' van, zie hierboven) en gaat niet verder naar de pagina:
     * Searchanise zet op collectiepagina's bij elke Esc op het document de pagina bovenaan (widgets.js: hide() doet
     * window.scrollTo zonder positie), en dat was achter de uitschuivende lade te zien.
     * Focusval: Tab blijft binnen de lade.
     */
    lade.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.stopPropagation();
        return;
      }
      if (e.key !== 'Tab') return;
      var kandidaten = lade.querySelectorAll('a[href], button:not([disabled]), summary, input, [tabindex]:not([tabindex="-1"])');
      var lijst = Array.prototype.filter.call(kandidaten, focusbaar);
      if (!lijst.length) return;
      var eerste = lijst[0];
      var laatste = lijst[lijst.length - 1];
      var nu = document.activeElement;
      var paneel = lade.querySelector('[data-sn-lade-paneel]');
      if (e.shiftKey && (nu === eerste || nu === paneel)) {
        e.preventDefault();
        laatste.focus();
      } else if (!e.shiftKey && nu === laatste) {
        e.preventDefault();
        eerste.focus();
      }
    });
  }

  /* ------------------------------------------------------------------- starten -- */

  function init() {
    balk = document.querySelector('[data-sn]');
    lade = document.querySelector('[data-sn-lade]');
    if (!balk || balk.hasAttribute('data-sn-gekoppeld')) return;
    balk.setAttribute('data-sn-gekoppeld', '');
    open = null;
    openDoor = null;

    Array.prototype.forEach.call(balk.querySelectorAll('[data-sn-item]'), koppelItem);

    var burger = burgerKnop();
    if (burger) {
      burger.addEventListener('click', function (e) {
        e.preventDefault();
        if (ladeOpen()) sluitLade();
        else openLade();
      });
    }

    /* Chatregel in Geuradvies (desktop): het menu dicht, sentir-chat.js doet de rest. */
    balk.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-sentir-chat-open]')) sluitPanelen(true);
    });

    if (lade && !lade.hasAttribute('data-sn-gekoppeld')) {
      lade.setAttribute('data-sn-gekoppeld', '');
      koppelLade();
    }

    balk.classList.add('is-klaar');

    window.SentirNav = { sluitPanelen: sluitPanelen, openLade: openLade, sluitLade: sluitLade };

    /* Een tik van vóór dit script (sections/header.liquid, "Vroege tik"). */
    var wacht = window.SentirNavWacht;
    window.SentirNavWacht = null;
    if (wacht && document.contains(wacht)) wacht.click();
  }

  /* Klikken naast een open menu sluit het. Een klik op een andere menuknop opent die al (zie toon). */
  document.addEventListener('click', function (e) {
    if (!open || open.contains(e.target)) return;
    verberg(open);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (!open) return;
    var item = open;
    var binnen = item.contains(document.activeElement);
    verberg(item, true, true);
    if (binnen) {
      var knop = knopVan(item);
      if (knop) knop.focus();
    }
  });

  /* Een open megamenu bovenaan de pagina schuift mee als je scrolt; de waas moet erachteraan. */
  window.addEventListener(
    'scroll',
    function () {
      if (!open || waasBeeld) return;
      waasBeeld = window.requestAnimationFrame(function () {
        waasBeeld = 0;
        zetWaas();
      });
    },
    { passive: true }
  );

  function opBreedte() {
    sluitPanelen(true);
    if (breed.matches) sluitLade({ direct: true, focus: false });
  }
  if (typeof breed.addEventListener === 'function') breed.addEventListener('change', opBreedte);
  else if (typeof breed.addListener === 'function') breed.addListener(opBreedte);

  /* Terug naar deze pagina met de terugknop (bfcache): niets mag nog open staan of de pagina vastzetten. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    sluitPanelen(true);
    sluitLade({ direct: true, focus: false });
    zetLos();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-sn]')) init();
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-sn]')) {
      sluitLade({ direct: true, focus: false });
      zetLos();
    }
  });

  init();
})();
